import React, { useEffect, useState } from 'react'
import ItemsApp, { IItemModel } from './ItemsApp'
import SingleItemContent from './SingleItemContent'
import { Skeleton } from '@mui/material'
import { error } from 'console'
import { handleRequestError } from '../../services/api'
import { useDispatch } from 'react-redux'
import ViewSingleItemPage from './ViewSingleItemPage'

interface IQuickSingleItemPreviewProps {
    itemId: number
}

export default function QuickSingleItemPreview(props: IQuickSingleItemPreviewProps) {

    const dispatch = useDispatch()

    const { itemId } = props

    return <ViewSingleItemPage customId={itemId} />

    // const [item, setItem] = useState<IItemModel | null>(null)
    // const [prevItemId, setPrevItemId] = useState<number | null>(null)

    // const itemsApp = new ItemsApp()

    // const loadItem = () => {
    //     if (prevItemId === itemId){
    //         return;
    //     }

    //     itemsApp.singleInstanceDetails(itemId)
    //         .then(response => {
    //             setItem(response.data)
    //             setPrevItemId(itemId)
    //         })
    //         .catch(error => {
    //             handleRequestError(error, dispatch)
    //         })
    // }

    // useEffect(() => {
    //     loadItem()
    // }, [itemId])

    // if (!item){
    //     return(
    //         <>
    //             <Skeleton variant="text" width={300} height={50} />
    //             <Skeleton variant="text" width={150} height={20} />
    //             <Skeleton variant="rectangular" width={"100%"} height={400} style={{ marginTop: 20 }} />
    //             <Skeleton variant="rectangular" width={"100%"} height={200} style={{ marginTop: 10 }} />
    //             <Skeleton variant="rectangular" width={"100%"} height={200} style={{ marginTop: 10 }} />
    //         </>
    //     )
    // }

    // return(
    //     <>
    //         <SingleItemContent item={item} />
    //     </>
    // )
}